export default "__VITE_ASSET__7h6Mol3r__"